import React from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageResize from "quill-image-resize-module-react";
import ImageUploader from "quill-image-uploader";
import 'quill-image-uploader/dist/quill.imageUploader.min.css';
// import { VideoHandler } from "quill-upload";
import "./Editor.css";


Quill.register("modules/imageUploader", ImageUploader);
Quill.register("modules/imageResize", ImageResize);
// Quill.register("modules/videoHandler", VideoHandler);
var Image = Quill.import('formats/image');
Image.className = 'custom-class-to-image';
Quill.register(Image, true);

function Editor({
    value = "",
    onChange,
    placeholder = "Content ",
    className = "",
    id = "ql-editor",
}) {
    return (
        <ReactQuill
            theme={"snow"}
            onChange={onChange}
            value={value}
            modules={Editor.modules}
            formats={Editor.formats}
            bounds={"#root"}
            placeholder={placeholder}
            className={className}
            id={id}
        />
    );
}

Editor.modules = {
    toolbar: [
        [{ header: "1" }, { header: "2" }, { font: [] }],
        [{ size: [] }],
        [
            "bold",
            "italic",
            "underline",
            "strike",
            "blockquote",
            { align: [] },
            { color: [] },
            { background: [] },
        ],
        [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
            { script: "sub" },
            { script: "super" },
        ],
        ["link", "image"],
        ["clean"],
    ],
    clipboard: {
        // toggle to add extra line breaks when pasting HTML:
        matchVisual: false,
    },
    imageResize: {
        parchment: Quill.import("parchment"),
        modules: ["Resize", "DisplaySize"],
    },
    imageUploader: {
        upload: (file) => {
            return new Promise((resolve, reject) => {
                const formData = new FormData();
                formData.append("media", file);
                formData.append("project_name", "warc");
                formData.append("media_type", "image");

                fetch(
                    "https://hub-services.volkeno.com/api/v1/app/upload-file/",
                    {
                        method: "POST",
                        body: formData,
                    }
                )
                    .then((response) => response.json())
                    .then((result) => {
                        console.log(result);
                        if (result?.success) {
                            resolve(result.file_url);
                        } else {
                            reject("Upload failed");
                        }
                    })
                    .catch((error) => {
                        reject("Upload failed");
                        console.error("Error:", error);
                    });
            });
        },
    },
    // videoHandler: {
    //     upload: (file) => {
    //         console.log("file", file);
    //         return new Promise((resolve, reject) => {
    //             const formData = new FormData();
    //             formData.append("media", file);
    //             formData.append("project_name", "warc");
    //             formData.append("media_type", "video");

    //             fetch(
    //                 "https://hub-services.volkeno.com/api/v1/app/upload-file",
    //                 {
    //                     method: "POST",
    //                     body: formData,
    //                 }
    //             )
    //                 .then((response) => response.json())
    //                 .then((result) => {
    //                     console.log(result);
    //                     if (result?.success) {
    //                         resolve(result.file_url);
    //                     } else {
    //                         reject("Upload failed");
    //                     }
    //                 })
    //                 .catch((error) => {
    //                     reject("Upload failed");
    //                     console.error("Error:", error);
    //                 });
    //         });
    //     },
    // },
};

/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
Editor.formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "indent",
    "script",
    "link",
    "image",
    "align",
    "color",
    "background",
];

export default Editor;
